import { EntityBase } from 'projects/sepidz-web-framework/src/lib/models/entity-base.model';
import { Item, StockInWebKind } from './item.model';

export class ItemCategory extends EntityBase {
  public Code:number;
  public Title: string;
  // public Color: string;
  public ApplyTax?: boolean;
  public ApplyService?: boolean;
  public PrintDisplayOrder: number;
  public ParentId?: number;
  public TaxApplyTypeId?: number;
  public TaxApplyTypeTitle: string;
  public TaxApplyTypeCode?: number;
  public ServiceApplyTypeId?: number;
  public ServiceApplyTypeTitle: string;
  public ServiceApplyTypeCode?: number;
  public Items: Item[];
  public Children: ItemCategory[];
  public DetailLedgerId?:number;
  public DelinoId?: number;
  public DeactiveInDelino?: boolean;
  public DeactiveInKiock?: boolean;
  public DeactiveInDigitalMenu?: boolean;
  public StockInWeb: StockInWebKind;
  public Image: string;
}
